import { Language } from '../types/callback';

export const getLanguage = (): Language => {
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'en' ? 'en' : 'ca';
};
